( function( window, document, $ ) {
    'use strict';

    $( window ).on( 'load', function() {
        // Add 'window load' logic here.
    } );

    $( document ).ready( function() {

        // --------------------------------------------------
        // DEFINE FUNCTIONS
        // --------------------------------------------------
        /**
         * ...
         */
        function init() {

            if ( typeof objectFitImages === 'function' ) {
                // Function can take options (https://github.com/bfred-it/object-fit-images#usage); but this should do it in most cases
                objectFitImages();
            }

        }

        /**
         * Wrapper around *any* logic which should be triggered on window scroll.
         */
        function scrollEventHandler( e ) {
            // Add 'window scroll' logic here.
        }

        /**
         * Wrapper around *any* logic which should be triggered on window resize.
         */
        function resizeEventHandler( e ) {
            // Add 'window resize' logic here.
        }

        // --------------------------------------------------
        // REGISTER EVENTS
        // --------------------------------------------------
        $( window ).on( 'scroll', scrollEventHandler );

        $( window ).on( 'resize', resizeEventHandler );

        // --------------------------------------------------
        // INIT
        // --------------------------------------------------
        init();

        // Run again when PJAX navigates to a new page
        if ( typeof Barba !== 'undefined' && typeof Barba.Dispatcher === 'object' ) {
            Barba.Dispatcher.on( 'newPageReady', function() {
                init();
            } );
        }
    } );
} )( window, document, jQuery );
